import { Dialog, IconButton, Typography } from '@mui/material'
import { Dismiss24Regular } from '@/components/Icon'
import SettingsPageContentBody from '@/components/Settings/SettingsPageContent/SettingsPageContentBody'
import SettingsSectionSidebar from '@/components/Settings/SettingsSectionSidebar'
import { useSettingsPageModel } from '@/components/Settings/useSettingsPageModel'
import { useSettingsModal } from './SettingsModalContext'
import styles from './settingsModal.module.scss'

export default function SettingsModal() {
  const { open, sectionId, setSectionId, closeSettings } = useSettingsModal()
  const { item } = useSettingsPageModel({ sectionId })

  return (
    <Dialog
      open={open}
      onClose={closeSettings}
      maxWidth={false}
      scroll="paper"
      aria-labelledby="settings-modal-title"
      slotProps={{
        paper: { className: styles.dialogPaper, elevation: 0 },
      }}
    >
      <header className={styles.header}>
        <Typography id="settings-modal-title" component="h2" className={styles.title}>
          Settings
        </Typography>
        <IconButton
          type="button"
          aria-label="Close settings"
          onClick={closeSettings}
          size="small"
          className={styles.closeButton}
        >
          <Dismiss24Regular className={styles.closeIcon} aria-hidden />
        </IconButton>
      </header>
      <div className={styles.body}>
        <aside className={styles.sidebar}>
          <SettingsSectionSidebar activeSectionId={sectionId} onSectionSelect={setSectionId} />
        </aside>
        <div className={styles.content}>{item ? <SettingsPageContentBody item={item} /> : null}</div>
      </div>
    </Dialog>
  )
}
